import { useState } from "react";
import { BiChevronRight } from "react-icons/bi";
import { LuSearch } from "react-icons/lu";
import { useQuery } from "react-query";
import { getTradeCharts, getTradeMetrics } from "../../api/trade";
import Loading from "../shared/Loading";
import TradeHistory from "./trade_history/TradeHistory";
import { Line } from "react-chartjs-2";
import RequestTabs from "./trade_request/RequestTabs";

const Trades = () => {
  const [hideHistory, setHideHistory] = useState(true);
  const { data, isLoading } = useQuery("trade-metrics", getTradeMetrics);
  const { data: tradeChart, isLoading: chartLoading } = useQuery(
    "trade-charts",
    getTradeCharts
  );

  return (
    <>
      {isLoading || chartLoading ? (
        <Loading />
      ) : (
        <div className="w-full h-full pt-5 px-5 pb-40 space-y-6">
          <div className="flex flex-col gap-5">
            <div className="font-dmsans font-bold text-[22px] text-[#070E05]">
              Trades
            </div>
            <div className="flex gap-5">
              <div className="w-1/2 bg-white rounded-lg p-4 gap-4 flex flex-col h-fit">
                <div className="chart-heading flex justify-between items-center font-dmsans">
                  <div className="text-[#181819E5] font-bold text-[14px]">
                    Trades
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full bg-[#2121F1]"></div>
                      <div className="text-[#1818196B] font-medium text-[12px]">
                        Crypto trades
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full bg-[#F0D961]"></div>
                      <div className="text-[#1818196B] font-medium text-[12px]">
                        Gift card trades
                      </div>
                    </div>
                  </div>
                </div>
                <TradeChart
                  cryptoSeries={tradeChart?.cryptoSeries || []}
                  giftCardSeries={tradeChart?.giftCardSeries || []}
                />
              </div>
              <div className="w-1/2">
                <div
                  className="flex flex-col gap-4"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(48%, 0fr))",
                  }}
                >
                  <div className="w-full bg-white font-dmsans flex flex-col gap-3 rounded-lg px-[28px] py-[10px]">
                    <div className="font-bold text-[14px] text-[#181819E5]">
                      Total trades
                    </div>
                    <div className="flex gap-2">
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Crypto trades
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data?.[0]?.totalCryptoTrades || 0
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Gift card trades
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data?.[0]?.totalGiftCardTrades || 0
                          ).toLocaleString()}
                        </div>
                      </div>                      
                    </div>
                  </div>

                  <div className="w-full bg-white font-dmsans flex flex-col gap-3 rounded-lg px-[28px] py-[8px]">
                    <div className="font-bold text-[14px] text-[#181819E5]">
                      Trades (in Naira)
                    </div>
                    <div className="flex gap-2">
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Crypto total
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          ₦
                          {Number(
                            data
                              ? data[0]?.totalCompletedCryptoAmount[0]?.fieldN
                              : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Gift Card total
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          ₦
                          {Number(
                            data
                              ? data[0]?.totalCompletedGiftCardAmount[0]?.fieldN
                              : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-full bg-white font-dmsans flex flex-col gap-3 rounded-lg px-[28px] py-[8px]">
                    <div className="font-bold text-[14px] text-[#181819E5]">
                      Giftcard Requests
                    </div>
                    <div className="flex gap-2">
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Pending
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data ? data[1]?.pending : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Completed
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data ? data[1]?.completed : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Declined
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data
                              ? data[1]?.declined 
                              : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-[12px] text-[#00000080]">
                          Processing
                        </div>
                        <div className="text-[26px] font-bold text-[#14142B]">
                          {Number(
                            data
                              ? data[1]?.processing
                              : 0
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 w-full rounded-lg flex flex-col gap-5">
            <div className="font-dmsans text-[18px]">
              <span className="font-bold">Trade history</span>{" "}
              {!hideHistory && <TradeHistory />}
            </div>
            <div className="flex justify-between font-medium text-[#4A4DE6] text-[14px] gap-1 items-center">
              <p></p>
              <div
                className="flex gap-2 cursor-pointer"
                onClick={() => setHideHistory((prev) => !prev)}
              >
                {hideHistory ? "View" : "Hide"} all trades{" "}
                <BiChevronRight className="text-[18px] mt-[1px]" />
              </div>
            </div>
          </div>

          <div className="bg-white p-4 w-full rounded-lg flex flex-col gap-6 overflow-hidden">
            <div className="font-dmsans text-[18px]">
              <span className="font-bold">Gift Card Requests</span>
            </div>
            <div className="customer_box flex justify-between items-center">
              <div className="flex gap-5"></div>
              <div className="">
                <div
                  className="border-[1px] border-[#E9EFF4] bg-white rounded-lg py-2 px-2 cursor-pointer -search-box"
                  title={`Search`}
                >
                  <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-2 w-full h-full relative">
                    <LuSearch className="text-[18px]" />
                    <input
                      className="w-[120px] placeholder:text-[#A0A3BD] text-[13px] outline-none text-black bg-transparent"
                      placeholder="search request"
                    />
                  </div>
                </div>
              </div>
            </div>

            <RequestTabs />
          </div>
        </div>
      )}
    </>
  );
};

export default Trades;

export function TradeChart({ cryptoSeries, giftCardSeries }) {
  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true,
          lineWidth: 0.5,
          tickBorderDash: [1, 10],
        },
        border: {
          dash: [50, 10],
        },
        ticks: {
          align: "end",
          display: true,
          font: {
            size: 11,
          },
          color: "#1818196B",
        },
      },
      y: {
        display: true,
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          font: {
            size: 11,
          },
          callback: function (val, index) {
            if (index == 0) {
              return 0;
            } else if (index == 3) {
              return 25;
            } else if (index == 6) {
              return 50;
            } else if (index == 9) {
              return 100;
            }
          },
        },
      },
    },
    maintainAspectRatio: false,
  };
  return (
    <div className="bar-container">
      <Line
        data={{
          labels: cryptoSeries?.map((ser) => ser.month) || [],
          datasets: [
            {
              label: "",
              data: cryptoSeries?.map((ser) => ser.totalAmount) || [],
              borderColor: "#2121F1",
              backgroundColor: "transparent",
              fill: false,
              tension: 0.5,
              pointStyle: false,
              borderWidth: 2,
            },
            {
              label: "",
              data: giftCardSeries?.map((ser) => ser.totalAmount) || [],
              borderColor: "#F0D961",
              backgroundColor: "transparent",
              fill: false,
              tension: 0.5,
              pointStyle: false,
              borderWidth: 2,
            },
          ],
        }}
        options={options}
        width={window.innerWidth}
        height={300}
      />
      <div
        className="chart-text"
        style={{
          color: "gray",
          fontSize: "13px",
        }}
      >
        {false ? <div>No data for this chart</div> : <></>}
      </div>
    </div>
  );
}
